<script lang="typescript">
    import { createEventDispatcher } from 'svelte'
    import ModalPanel from './components/ModalPanel.svelte';

    let dispatch = createEventDispatcher();
 
    function cancel() {
        dispatch("close");
    }
</script>

<ModalPanel style="top: 50%; left: 50%; transform: translate(-50%, -50%)" on:wantClose={cancel}>
    <div class="credits">
        <h2>Credits</h2>
        <dl>
            <dt>Code and Visuals</dt>
            <dd>David Pershouse (<a href="https://github.com/halfnelson/" target="_blank">halfnelson</a>)</dd>
            <dt>Puzzle Concept</dt>
            <dd>Gokigen Naname - Nikoli Co. Ltd</dd>
            <dt>Music By</dt>
            <dd>Scott Buckley – <a href="https://www.scottbuckley.com.au" target="_blank">www.scottbuckley.com.au</a></dd>
            <dt>Sound</dt>
            <dd>From <a href="https://Zapsplat.com">Zapsplat.com</a></dd>
            <dt>Icons</dt>
            <dd>Feather - Cole Bemis <a href="https://github.com/feathericons/feather/blob/master/LICENSE" target="_blank">MIT License</a></dd>
        </dl>
        <button on:click={cancel}>Close</button>
    </div>
</ModalPanel>


<style>
	.credits {
		width: 300px;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    dt {
        text-align: center;
        font-size: 0.8rem;
        margin-bottom: 0.25rem;
        margin-top: 1.2rem;
        font-weight: bold;
        font-family: sans-serif;
    }

    h2 {
        margin-bottom: 0;
        margin-top: 0;
    }

    button {
        margin-top: 1rem;
    }

    a, a:visited {
        color: var(--button-color);
    }
</style>

